export default class TemplateLogin {
  constructor() {
    this.$el = $(document.body);

    this.$el.on('click', event => this.closeModal(event));
    $('.admin-login-modal').on('click', () => this.openModal());
    this.modalWrapper = $('.password-page-modal-wrapper');
    this.modalContent = this.modalWrapper.find('.password-page-modal');
    this.openByDefault = this.modalWrapper.find('[data-open-modal]').length;

    if (this.openByDefault) {
      this.openModal();
    }
    $(window).on('resize', () => { this.positionModal(); });
  }

  closeModal(e) {
    if ($(e.target).hasClass('visible')) {
      this.modalWrapper.removeClass('visible').one('trend', () => {
        this.$el.removeClass('scroll-locked');
      });
    }
  }

  openModal() {
    this.$el.addClass('scroll-locked');
    this.positionModal();
    this.modalWrapper.addClass('visible');
  }

  positionModal() {
    this.modalContent.css({
      marginTop: -(this.modalContent.outerHeight() / 2),
      marginLeft: -(this.modalContent.outerWidth() / 2),
    });
  }
}
